/**
 * CSC cart feedback — shared screen-reader announcer for add-to-cart (Goal C).
 *
 * Every successful add (main custom PDP form via csc-pdp-cart.js, Dawn
 * <product-form>, and E9 cross-sell cards via cscCrossSellAdd) calls
 * window.cscCartFeedback.announce(...) so assistive tech hears the result
 * WITHOUT focus being stolen (the drawer already moves focus to its close
 * button — see cart-drawer.js).
 *
 * Exposes window.cscCartFeedback:
 *   - titleFromResponse(data) → best-effort product title from a /cart/add.js body
 *   - updateHeaderCount(count) → keeps the custom CSC header badge in sync
 *   - announce(title)         → updates a persistent body-level aria-live region:
 *                               "{title} added to cart. {N} items in your basket,
 *                               total £X." (N + total read from /cart.js so they
 *                               are always authoritative immediately post-add)
 *
 * The live region lives on <body> — NOT inside #CartDrawer — so the drawer's
 * section re-render via renderContents() never replaces it mid-announcement.
 */
(function () {
  if (window.cscCartFeedback) return;

  var LIVE_ID = 'csc-cart-live-region';

  function liveRegion() {
    var el = document.getElementById(LIVE_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = LIVE_ID;
    el.className = 'csc-cart-drawer__aria-live';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-atomic', 'true');
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function titleFromResponse(data) {
    if (!data) return '';
    if (Array.isArray(data.items) && data.items.length) {
      return data.items[0].product_title || data.items[0].title || '';
    }
    return data.product_title || data.title || '';
  }

  function formatMoney(cents, currency) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return amount.toLocaleString('en-GB', { style: 'currency', currency: currency || 'GBP' });
    } catch (e) {
      return '£' + amount.toFixed(2);
    }
  }

  function updateHeaderCount(count) {
    var value = parseInt(count, 10);
    if (isNaN(value) || value < 0) return;

    document.querySelectorAll('.csc-nav-cart').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart (' + value + ')');

      var badge = link.querySelector('.csc-nav-cart-count');
      if (value > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'csc-nav-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = String(value);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function announce(title) {
    var region = liveRegion();
    var name = (title && String(title).trim()) || 'Item';
    // Single textContent write = one clean polite announcement. We resolve the
    // authoritative count + total from /cart.js first, then write once; the
    // catch path still guarantees the add is announced if the lookup fails.
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var noun = count === 1 ? 'item' : 'items';
        updateHeaderCount(count);
        region.textContent =
          name + ' added to cart. ' + count + ' ' + noun + ' in your basket, total ' +
          formatMoney(cart.total_price, cart.currency) + '.';
      })
      .catch(function () {
        region.textContent = name + ' added to cart.';
      });
  }

  window.cscCartFeedback = {
    titleFromResponse: titleFromResponse,
    updateHeaderCount: updateHeaderCount,
    announce: announce
  };
})();
